import React from "react";
import { withTranslation } from "react-i18next";
import { observer, inject } from "mobx-react";
import {
	Button, Menu, Modal, Input, Icon, Loader, Header,
	Table, TableRow, TableHeaderCell, TableHeader, TableCell, TableBody,
} from "semantic-ui-react";
import moment from "moment";
import axios from "axios";

class AdvanceSearch extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			filter: '',
			error: false,
			showLoader: false,
			results: [],
			noSearchPhrase: true
		};
	}

	componentDidMount() {
	}

	componentDidUpdate(prevProps, prevState) {
	}

	open() {
		if (this.props.app.ui.filterString.length) {
			this.setState({ filter: this.props.app.ui.filterString });
			this.load();
		}
		this.setState({ open: true, noSearchPhrase: true });
	}

	close() {
		this.setState({ open: false, filter: "", results: [] });
	}

	changeFilter(filter) {
		this.setState({ filter });
	}

	loadDate(date) {
		this.props.app.ui.setFilterString(this.state.filter);
		this.props.app.ui.setCalStart(moment(date).startOf("day").valueOf());
		this.close();
	}

	filterSearch() {
		if (this.state.filter) {
			this.load();
		}
	}

	onKeyPress(e) {
		if (e.key === 'Enter') {
			this.load();
		}
	}

	async load() {
		const jwttoken = localStorage.getItem("binfra_token");
		let search_phrase = this.state.filter;

		if(search_phrase.length === 0) return; else console.log('No search Phrase');
		
		this.setState({ error: false, showLoader: true, results: [], noSearchPhrase: false });
		
		try {
			const res = await axios.get(
				process.env.REACT_APP_SERVER_URL +
				"/advanceSearch/" + search_phrase +
				"?v=" + process.env.REACT_APP_SERVER_VERSION + "&" +
				Math.random(),
				{
					headers: {
						Authorization: "Bearer " + jwttoken,
					},
				}
			);

			if (res.data) {
				this.setState({
					error: false,
					showLoader: false,
					results: Object.values(res.data.projects)
				});
			}
		} catch (error) {
			if (error.response && error.response.status === 401) {
				this.props.app.ui.setLoginNecessary("callback", this.load.bind(this));
			}
			this.setState({ error: true, loading: false });
			console.log(error);
		}
	}

	render() {
		const search_result_module = [];
		const dx = [];
		for (let project of this.state.results) {
			let display_project = true;
			let rowSpan = Object.values(project.process).length;
			Object.values(project.process).forEach(process => {
				search_result_module.push(
					<TableRow key={project.id + "_" + process.id}>
						{display_project ? <TableCell rowSpan={rowSpan}>{project.name}</TableCell> : ''}
						{display_project ? <TableCell rowSpan={rowSpan}>{project.bstn}</TableCell> : ''}
						<TableCell>{process.name}</TableCell>
						<TableCell>{moment(process.job_start).format('lll')}</TableCell>
						<TableCell>
							<Button content={this.props.t("advance_search.calendar_view")}
								icon="calendar alternate outline icon"
								onClick={e => this.loadDate(moment(process.job_start).valueOf())}
								className={"advance_search"}
							/>
						</TableCell>
					</TableRow>
				);
				display_project = false;
			});
		}

		if (this.state.noSearchPhrase)
			dx.push(
				<div className="advanceSearchNothing" key="advanceSearchNothing">
					{this.props.t("advance_search.noSearchPhrase")}
				</div>
			);
		else if (!search_result_module.length && !this.state.showLoader)
			dx.push(
				<div className="advanceSearchNothing" key="advanceSearchNothing">
					{this.props.t("advance_search.noData")}
				</div>
			);
		else
			dx.push(
				<div className="advanceSearchResult">
					<Table celled striped selectable structured color={'red'}>
						<TableHeader color={'black'} inverted>
							<TableRow>
								<TableHeaderCell>{this.props.t("advance_search.table_head.project")}</TableHeaderCell>
								<TableHeaderCell>{this.props.t("advance_search.table_head.bstn")}</TableHeaderCell>
								<TableHeaderCell>{this.props.t("advance_search.table_head.process")}</TableHeaderCell>
								<TableHeaderCell>{this.props.t("advance_search.table_head.date")}</TableHeaderCell>
								<TableHeaderCell>{this.props.t("advance_search.table_head.view")}</TableHeaderCell>
							</TableRow>
						</TableHeader>
						<TableBody>{search_result_module}</TableBody>
					</Table>
				</div>
			);

		return (
			<Modal
				centered={false}
				className="advanceSearchModal"
				trigger={
					<Button.Group>
						<Button
							content={this.props.t("advance_search.heading")}
							icon="search icon"
							onClick={e => this.open()}
							className={"advance_search"}
						/>
					</Button.Group>

				}
				open={this.state.open}
				onClose={e => this.close()}
			>
				<React.Fragment>
					<Menu>
						<Menu.Item header>
							{this.props.t("advance_search.heading")}
						</Menu.Item>
						<Menu.Item>
							<Input
								placeholder={this.props.t("filter")}
								value={this.state.filter}
								onChange={(e, { value }) =>
									this.changeFilter(value)
								}
								onKeyPress={this.onKeyPress.bind(this)}
								autoFocus={true}
								action={{ icon: 'search', onClick: this.filterSearch.bind(this) }}
							/>
						</Menu.Item>
						<Menu.Menu position="right">
							<Menu.Item
								name="close it"
								onClick={e => this.close()}
							>
								<Icon name="close" />
							</Menu.Item>
						</Menu.Menu>
					</Menu>
					<Modal.Content>
						<div className="advanceSearchWrapper">
							{this.state.error ? (
								<Header
									style={{ margin: 20, textAlign: "center", display: "block" }}
									className="connectionError"
									icon
								>
									<Icon name="wifi" />
									{this.props.t("loader.networkError")}
									<Header.Subheader>
										<Button onClick={(x) => this.load()}>
											{this.props.t("loader.tryAgain")}
										</Button>
									</Header.Subheader>
								</Header>
							) : this.state.showLoader ? (
								<Loader
									style={{ margin: 20, color: '#000' }}
									active
									inline="centered"
									size="large"
								>
									{this.props.t("report.loading")}
								</Loader>
							) : (dx)
							}
						</div>
					</Modal.Content>
				</React.Fragment>
			</Modal>
		);
	}
}

export default withTranslation()(inject("app")(observer(AdvanceSearch)));
